<template>
  <div class="text-center ">
    <v-modal-contents ref="modal_contents_agree" >

      <template v-slot:close>
        <!--        убираем close-->
        <div></div>
      </template>

      <template v-slot:title>

        <div class="terms_of_use__title mt-30 pl-3 ">
          <div class="h2_title">Условия использования персональных данных</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
            <div v-html="terms"></div>
          <div class="mt-30">
            <button class="px-30 btn_bordered "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>
    <v-dialog content-class="dialog_custom dialog_rezume" v-model="dialog" width="516" relative persistent>

      <v-card>

        <v-card-text>
          <v-form ref="form"  action="#" @submit.prevent="" class="" v-model="valid" lazy-validation>
            <section class="call">
              <div class="call__inner">
                <button class="call__close" @click="dialog = false">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="call__header">
                  <h2 class="call__title">
                    Отправить резюме
                  </h2>
                </div>
                <div  class="call__form">
                  <label for="name" class="call__label">
                    <v-text-field
                        v-model="name"
                        :rules="nameRulesRu"
                        required=""
                        solo
                        id="name"
                        class="call__input"
                    >
                      <template v-slot:label>
                        Ваше имя <span>*</span>
                      </template>
                    </v-text-field>
                  </label>

                  <label for="tell" class="call__label">
                    <v-text-field
                        v-model="tel_input"
                        :rules="tel_inputRulesRu"
                        required
                        solo
                        id="tel"
                        oninput="this.value = this.value.replace(/[^\d+]/g,'');"
                        class="call__input "
                    >
                      <template v-slot:label>
                        Телефон <span>*</span>
                      </template>
                    </v-text-field>
                  </label>
                  <label for="email" class="call__label">
                    <v-text-field
                        v-model="email"
                        required
                        solo
                        id="email"
                        class="call__input"
                    >
                      <template v-slot:label>
                        E-mail
                      </template>
                    </v-text-field>
                  </label>

                  <div
                      class="summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                      id="summary"
                  >
                    <input
                        type="file"
                        multiple
                        name="fields[assetsFieldHandle][]"
                        id="assetsFieldHandle"
                        class="w-px h-px opacity-0 overflow-hidden absolute"
                        @change="onChange"
                        ref="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                    />

                    <label for="assetsFieldHandle" class="block cursor-pointer">
                      <div>Выберите или перетащите сюда файл в формате PDF, DOC, DOCX, RTF, JPG</div>
                    </label>
                    <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                      <li class="text-sm p-1 text-left" v-for="(file, index) in filelist" :key="index">
                        {{ file.name }}
                        <button
                            class="ml-2 remove_file"
                            type="button"
                            @click="remove(filelist.indexOf(file))"
                            title="Remove file"
                        >
                          Удалить
                        </button>
                      </li> 
                    </ul>
                  </div>

                  <!-- SmartCaptcha -->
                  <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'" class="w-100"></div>

                  <div class="form_upload__item">
                    <v-checkbox
                        v-model="checkbox"
                        :rules="[(v) => !!v || 'Это обязательный пункт']"
                        required
                        color="red"
                    >
                      <template v-slot:label>
                        <div class="customLabelForm">
                          Я выражаю согласие с <a href="javascript:void(0);" target="_blank" @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями использования</a> моих персональных данных для обработки данного обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с
                          <a :href="policy"  @click="linkOpen(policy)" class="position-relative zi-1">Политикой конфиденциальности</a> и <a :href="agreement" @click="linkOpen(agreement)" class="position-relative zi-1">Пользовательским соглашением.</a>
                        </div>
                      </template>
                    </v-checkbox>

                    <!--            :rules="[(v) => !!v || 'Это обязательный пункт']"-->
                    <!--            required-->
                    <v-checkbox
                        v-model="consentToInform"

                        color="red"
                        class="mt-0"
                    >
                      <template v-slot:label>
                        <div class="customLabelForm">
                          Я выражаю согласие на информирование меня о продуктах, акциях, выгодных предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и партнеров.
                        </div>
                      </template>
                    </v-checkbox>


                  </div>
                  <div class="call__box">
<!--                    <p class="call__text">-->
<!--                      Нажимая кнопку “Отправить”, вы соглашаетесь на обработку персональных данных.-->
<!--                    </p>-->
                    <button :disabled="!valid" class="call__btn "
                            @click="validate">
                      Отправить
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </v-form>

        </v-card-text>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import VModalContents from "./modal_contents";

export default {
  components: {
    VModalContents: VModalContents,
  },
    props: {
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
  delimiters: ["${", "}"],
  data() {
    return {
      checkbox: false,
      consentToInform: false,

      captchaPassed: false,
      dialog: false,
      valid: true,

      name: "",
      nameRulesRu: [
        (v) => !!v || "Поле 'Имя' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Имя' не можети быть меньше 3 символов",
      ],

      email: "",
      // тут без валидации e-mail
      // emailRules: [
      //   (v) => !!v || "E-mail is required",
      //   (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      // ],

      tel_input: "",
      tel_inputRulesRu: [
        (v) => !!v || "Поле 'Телефон' обязательно для заполнения",
        (v) => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || "Телефон заполнен неправильно",
      ],

      // upload drag-and-drop file
      filelist: [],
    };
  },
  methods: {
    linkOpen(url) {
      window.open(url, '_blank');
    },

    // Captcha
    initCaptcha() {
      window.smartCaptcha.render('captcha-container', {
        sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
        callback: this.onCaptchaSuccess,
      });
    },
    onCaptchaSuccess(token) {
      this.captchaPassed = true;
      this.form.captchaToken = token;
    },
    // Captcha end
    validate() {
      if (!this.$refs.form.validate()) return false;
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }

        var VueObject = this;
        var formData = new FormData();
        $.each(VueObject.filelist, function(key, value){
            formData.append(key, value);
        });

      let newTel = VueObject.tel_input;
      if (newTel[0] === '8') {
        newTel = newTel.slice(1); // если первая цифра 8, удаляем её
      }
      console.log(newTel);

        formData.append("name", VueObject.name);
        formData.append("phone", newTel);
        formData.append("email", VueObject.email);
        formData.append("ajaxPost", "Y");

      $.ajax({
          "type": "POST",
          "url": "/ajax/contacts-resume.php",
          "data": formData,
          "cache": false,
          "dataType": 'json',
          "processData": false, // Не обрабатываем файлы (Don't process the files)
          "contentType": false, // Так jQuery скажет серверу, что это строковой запрос
        "success": function (res) {
          console.log(res);
          VueObject.dialog = false;
          $(".text_result_new .send__title").text("Резюме отправлено");
          $(".text_result_new .send__subtitle").text("Мы свяжемся с Вами в ближайшее время");
          $(".text_result_new").slideDown(300);
          VueObject.$refs.form.reset();
        },
        "error": function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(thrownError);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    modal_open(event) {
      if (this.dialog) {
        this.dialog = false;
      } else {
        this.dialog = true;
        this.$nextTick(function () {
          this.initCaptcha();
        });
      }
    },

    // upload drag-and-drop file

    onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },

    // upload drag-and-drop file end

  },
  watch: {
    captchaPassed() {
      // this.sendForm();
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }
    },
  }
};
</script>
<style lang="scss">
.dialog_rezume {
  & .drag_form {
    background: rgba(249, 66, 55, 0.06);
    border: 1px dashed #f94237 !important;
    box-sizing: border-box;
    border-radius: 15px;
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    display: flex;
    align-items: center;
    color: #000000;
    opacity: 0.7;
    text-align: center;

  }
  & .summary label {
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    align-items: center;
    color: #000000;
    opacity: 0.7;
    width: 100%;
    margin: auto;
    height: 100%;
    padding: 40px 21px;
    justify-content: center;
  }
}
</style>
